import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { IconComponent } from './ui/icon.component';
import { WhatsappModalService } from '../services/whatsapp-modal.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, IconComponent],
  template: `
    <footer class="bg-[#050505] text-gray-300 py-12 border-t border-white/5">
      <div class="container mx-auto px-4 md:px-6">
        
        <!-- Top Section with Columns -->
        <div class="flex flex-col md:flex-row justify-between mb-12 gap-12 md:gap-8">
          
          <!-- Column 1: Logo -->
          <div class="flex flex-col gap-6 flex-shrink-0">
            <img src="/images/logo-branca.svg" 
                 alt="beetrack Logo" 
                 width="120"
                 height="32"
                 loading="lazy"
                 class="h-8 w-auto object-contain self-start">
          </div>

          <!-- Group 2: Contact and Social Media close together -->
          <div class="flex flex-col md:flex-row gap-12 md:gap-16">
            
            <!-- Column 2: Contact -->
            <div class="flex flex-col">
              <h3 class="text-white font-semibold text-lg mb-4">Contato</h3>
              <div class="flex flex-col gap-4 text-base">
                <a href="mailto:comercial@beetrack.com.br" class="flex items-center gap-3 hover:text-white transition-colors">
                  <app-icon name="mail" [size]="20"></app-icon>
                  comercial@beetrack.com.br
                </a>
              </div>
            </div>

            <!-- Column 3: Social Media -->
            <div class="flex flex-col">
              <h3 class="text-white font-semibold text-lg mb-4">Redes Sociais</h3>
              <div class="flex gap-4">
                <a href="https://www.linkedin.com/company/beetrackcombr/?viewAsMember=true" target="_blank" class="flex items-center justify-center w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 hover:text-white transition-colors" aria-label="LinkedIn">
                  <app-icon name="linkedin" [size]="20"></app-icon>
                </a>
                <a href="https://www.facebook.com/profile.php?id=61580736390932&locale=pt_BR" target="_blank" class="flex items-center justify-center w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 hover:text-white transition-colors" aria-label="Facebook">
                  <app-icon name="facebook" [size]="20"></app-icon>
                </a>
                <a href="https://www.instagram.com/_beetrack" target="_blank" class="flex items-center justify-center w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 hover:text-white transition-colors" aria-label="Instagram">
                  <app-icon name="instagram" [size]="20"></app-icon>
                </a>
              </div>
            </div>

          </div>
        </div>

        <!-- Bottom Section: Copy & Links -->
        <div class="flex flex-col md:flex-row justify-between items-center gap-4 pt-8 border-t border-white/10 text-sm">
          <div class="flex flex-col gap-1">
            <span class="text-gray-400">beetrack Tecnologia — Desde 2019 protegendo operações frigorificadas em todo o Brasil</span>
            <span>&copy; 2019-{{ currentYear }} beetrack Tecnologia Ltda. Todos os direitos reservados.</span>
          </div>
          <div class="flex flex-wrap justify-center gap-4 md:gap-6">
             <a href="#" class="hover:text-white transition-colors">Privacidade</a>
             <span class="text-gray-600 hidden md:inline">|</span>
             <a href="#" class="hover:text-white transition-colors">Termos</a>
             <span class="text-gray-600 hidden md:inline">|</span>
             <a href="#" class="hover:text-white transition-colors">Suporte</a>
          </div>
        </div>

      </div>
    </footer>
  `
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  private router = inject(Router);
  whatsappModalService = inject(WhatsappModalService);

  get isV2() {
    return this.router.url.includes('/v2');
  }

  get isV3() {
    return this.router.url.includes('/v3');
  }

  openWhatsapp(url: string) {
    this.whatsappModalService.open(url);
  }
}